import { render, staticRenderFns } from "./MyOrganisedEvents.vue?vue&type=template&id=aa3d7294"
import script from "./MyOrganisedEvents.vue?vue&type=script&lang=js"
export * from "./MyOrganisedEvents.vue?vue&type=script&lang=js"
import style0 from "./MyOrganisedEvents.vue?vue&type=style&index=0&id=aa3d7294&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports